const AddToBasketMixin = {
  data() {
    return {}
  },
  methods: {
    compareLongAvailabilityText(availability) {
      return availability.text === this.$t('global.deliveryOnDemand') ||
          availability.text === this.$t('global.deliveryNotAvailable') ||
          availability.text === this.$t('ITEM_STOCK_NOT_AVAILABLE');
    }
  }
};

export default AddToBasketMixin;
